module.exports = __webpack_public_path__ + "public/img/640 (1).d67344c0.gif";